import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ToggleContainerComponent extends Component {
  @tracked state = false;

  @action
  toggleAction() {
    this.state = !this.state;
  }
}
